export const projectTemplatesTranslationsEn = {
  allAboutTemplates: 'All about templates',
  backToTemplates: 'Back to project templates',
  bannerEditModeTitle: 'Edit template (changes are saved automatically)',
  bannerEditModeSubtitle:
    'When you use this template to create a new project, you can set a new start date. Collisions will be resolved automatically in the process.',
  bannerPreviewModeTitle: 'Preview',
  createFirstTemplate: 'Create your first project template',
  createFlowSelectModalTitle: 'Create a new template',
  createFlowSelectModalSubtitle: 'Choose a project which you want to use as base for you template.',
  createFlowDetailsModalTitle: 'Set a name and a description for your template',
  createProjectTemplate: 'Create project template',
  creatingProjectTemplate: 'Creating project template',
  createTemplate: 'Create template',
  duplicateTemplateModalTitle: 'Duplicate template',
  duplicateTemplateModalSubtitle:
    'This template has structure, trades, milestones, activities and dependencies.',
  deleteConfirmationModalTitle: 'Delete project template',
  deleteConfirmationModalSubtitle:
    'Do you really want to delete the selected project template ‘{projectTemplate}’ ? ',
  deleteNotificationTitle: 'Project template successfully deleted',
  editName: 'Edit name',
  licenseTeaserTitle: 'You are interested in project templates?',
  licenseTeaserText:
    'You can create templates for the for projects including structure, activities, milestones and more.\nThen you use them company-wide for each of your projects.',
  noProjectTemplatesAvailable: 'No project template exists',
  noProjectTemplatesAvailableHintFirstLine:
    'You can create templates for the for projects including structure, activities, milestones and more.',
  noProjectTemplatesAvailableHintSecondLine:
    'Then you use them company-wide for each of your projects.',
  noProjectTemplatesResults: 'No matching project templates available',
  noProjectResults: 'No matching projects available',
  noProjectsExist: 'There are no projects available to create a template from',
  searchProjectTemplate: 'Search project template',
  templateSelectionTitle: 'Choose template',
  templateSelectionSidebarTitle: 'Available project templates',
  templateSelectionSidebarSubtitle: 'Select a start date and a template to see its preview.',
  templateSelectionFirstStep: '1. Select a start date:',
  templateSelectionSecondStep: '2. Select a template:',
  templateSelectionEstimatedEndDate: 'Estimated end date:',
  templateSelectionCreate: 'Create project',
};
